"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CurrencyLabelFormatters = require("../internal/utils/CurrencyLabelFormatters");

var _default = _CurrencyLabelFormatters.formatCurrencyCode;
exports.default = _default;
module.exports = exports.default;